/**
 * Module: utilities
 * General helper functions
 */

function init() {
	// Add class to HTML element to allow us to write CSS that is dependent on the availability of touch capability
	var touchClass = ( isTouchDevice() ) ? 'touch' : 'no-touch';
	$('html').addClass( touchClass );
}

/**
 * Convert dash separated values into camel case format
 * @param  {string} input The dash separated string to convert
 * @return {string}       The camel case formatted string
 */
function dashToCamel( input ) {
	return input.toLowerCase().replace(/-(.)/g, function(match, group1) {
		return group1.toUpperCase();
	});
}

/**
 * Determine if a given string is a valid email address
 * @param  {string} email The email address
 * @return {bool}
 */
function isEmail( email ) {
	var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	return regex.test( email );
}

/**
 * Determine if the device supports touch interaction
 */
function isTouchDevice() {
	return 'ontouchstart' in window || navigator.maxTouchPoints;
}

/**
 * Public API
 */
module.exports = {
	dashToCamel: dashToCamel,
	isEmail : isEmail,
	isTouchDevice : isTouchDevice,
	init : init
};


// WEBPACK FOOTER //
// ./scripts/components/utilities.js